import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import {
  DiffValue,
  DIFF_VALUE_TYPE,
  Decimal,
  AbbreviatedDecimal,
  NoValue
} from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  diff: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  variance: {
    fontSize: theme.typography.body2.fontSize,
    padding: theme.spacing(0.5)
  },
  icon: {
    fontSize: '0.8rem'
  }
}));

const Variance = ({ field, record, column }) => {
  const showAbbreviatedValue = column?.showAbbreviatedValue;
  const overrideClasses = column?.classes;
  const Component = showAbbreviatedValue ? AbbreviatedDecimal : Decimal;
  const hours = record[field];
  const classes = useStyles({ classes: overrideClasses });

  const varianceType =
    hours < 0
      ? DIFF_VALUE_TYPE.NEGATIVE
      : hours > 0
      ? DIFF_VALUE_TYPE.POSITIVE
      : DIFF_VALUE_TYPE.NEUTRAL;

  return hours !== null ? (
    <DiffValue className={classes.diff} diffValueType={varianceType}>
      {varianceType === DIFF_VALUE_TYPE.POSITIVE ? (
        <RemoveIcon className={classes.icon} />
      ) : null}
      {varianceType === DIFF_VALUE_TYPE.NEGATIVE ? (
        <AddIcon className={classes.icon} />
      ) : null}
      <Component
        className={classes.variance}
        value={Math.abs(hours)}
        precision={2}
      />
    </DiffValue>
  ) : (
    <NoValue />
  );
};

Variance.propTypes = {
  field: PropTypes.string,
  record: PropTypes.object,
  column: PropTypes.object
};

export default Variance;
